import React from 'react'
import { any } from 'prop-types'

import InfoBox from './InfoBox'
import FaInfoCircle from 'react-icons/lib/fa/info-circle'

import styles from './TableDay.styl'

export default class BigCard extends React.Component {
	static propTypes = {
		unit: any,
		value: any,
		valueUT: any,
		title: any,
		isPA: any,
		serie: any,
		recoveryBPM: any,
		maxBPM: any
	}
	constructor(props) {
		super(props)
		this.state = { info: false }
	}

	render() {
		const { unit, value, valueUT, title, isPA, serie, recoveryBPM, maxBPM } = this.props
		const UTValue = valueUT ? <span> / { valueUT }</span> : ' '
		return (
			<div className={ styles['secondary-info-container'] }>
				{ isPA ? <button className={ styles.info } onClick={ () => this.setState({ info: true }) }><i><FaInfoCircle height="20px" width="20px" /></i></button> : null }
				{ this.state.info ? <InfoBox serie={ serie } recoveryBPM={ recoveryBPM } maxBPM={ maxBPM } close={ () => this.setState({ info: false }) } /> : null }
				<p>{ title }<br />({ unit })</p>
				<p className={ styles.smaller }>{ value }{ UTValue }</p>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/Table/BigCard.js